export function postToWac(
    iframeElement: HTMLIFrameElement,
    wacUrl: string,
    token?: string,
    onSubmit?: () => void
) {
    const accessTokenRegex = /([?&])access_token=([^&]+)/;
    const accessTokenTtlRegex = /([?&])access_token_ttl=([^&]+)/;
    const replaceValue = '$1';
    let accessToken = null;
    let accessTokenTtl = null;
    if (accessTokenRegex.test(wacUrl)) {
        accessToken = decodeURIComponent(wacUrl.match(accessTokenRegex)[2]);
        wacUrl = wacUrl.replace(accessTokenRegex, replaceValue);
    }

    if (accessTokenTtlRegex.test(wacUrl)) {
        accessTokenTtl = decodeURIComponent(wacUrl.match(accessTokenTtlRegex)[2]);
        wacUrl = wacUrl.replace(accessTokenTtlRegex, replaceValue);
    }

    wacUrl += '&hh=1'; // hide header
    wacUrl += '&mscc=1'; // hide cookie banner

    iframeElement.onload = () => {
        iframeElement.onload = null;

        const iframeDocument = iframeElement.contentDocument;

        if (!iframeDocument.body) {
            iframeDocument.write('<body><div></div></body>');
        }

        const formElement = iframeDocument.createElement('form');
        formElement.action = wacUrl;
        formElement.method = 'POST';
        formElement.style.visibility = 'hidden';

        if (accessToken) {
            const inputElement = iframeDocument.createElement('input');
            inputElement.type = 'hidden';
            inputElement.name = 'access_token';
            inputElement.value = accessToken;
            formElement.appendChild(inputElement);
        }

        if (accessTokenTtl) {
            const inputElement = iframeDocument.createElement('input');
            inputElement.type = 'hidden';
            inputElement.name = 'access_token_ttl';
            inputElement.value = accessTokenTtl;
            formElement.appendChild(inputElement);
        }

        if (token) {
            const tokenParts = token.split('&');
            for (let i = 0; i < tokenParts.length; i++) {
                const tokenPair = tokenParts[i].split('=');
                if (tokenPair.length === 2) {
                    const inputElement = iframeDocument.createElement('input');
                    inputElement.type = 'hidden';
                    inputElement.name = tokenPair[0];
                    inputElement.value = decodeURIComponent(tokenPair[1]);
                    formElement.appendChild(inputElement);
                }
            }
        }

        iframeDocument.body.appendChild(formElement);
        formElement.submit();

        if (onSubmit) {
            onSubmit();
        }
    };

    iframeElement.src = 'about:blank';
}
